import { useState } from "react";
import MobileMenu from "../../sections/mobileMenu/mobileMenu";
import Header from "../../sections/header/header";
import NotificationContent from "../../sections/notifications/NotificationContent";
import Footer from "../../sections/footer/footer";
import PopupForm from "../../sections/popupForm/popupForm";
import CallbackForm from "../../sections/callbackForm/callbackForm";

const Notifications = () => {
  const [message, setMessage] = useState("");

  return (
    <>
      <MobileMenu />
      <div className="page page--index page--cabinet">
        <Header />
        <main className="page__main">
          <NotificationContent message={message} />
        </main>
        <Footer />
        <PopupForm setMessage={setMessage} />
        <CallbackForm />
      </div>
    </>
  );
};

export default Notifications;
